import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MobileLayout } from '../../components/MobileLayout';
import { Tabs } from '../../components/ui/Tabs';
import { Card, CardContent, CardFooter } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Clock, MapPin, Home, ChevronRight, Check } from 'lucide-react';
import { useMaintenance, MaintenanceJob, JobStatus } from '../../context/MaintenanceContext';
const statusMap: Record<JobStatus, {
  label: string;
  cls: string;
}> = {
  da_accettare: {
    label: 'Da accettare',
    cls: 'bg-amber-50 text-amber-700 border-amber-200'
  },
  accettata: {
    label: 'Accettata',
    cls: 'bg-muted text-muted-foreground border-border'
  },
  in_corso: {
    label: '● In corso',
    cls: 'bg-coral/5 text-coral border-coral/20'
  },
  completata: {
    label: 'Completata',
    cls: 'bg-emerald-50 text-emerald-700 border-emerald-200'
  }
};
export function ManIncarichiPage() {
  const navigate = useNavigate();
  const {
    jobs,
    acceptJob
  } = useMaintenance();
  const [tab, setTab] = useState('attivi');
  const visible = jobs.filter(j => tab === 'attivi' ? j.status !== 'completata' : j.status === 'completata');
  return <MobileLayout data-id="element-2957">
      <div className="mb-6" data-id="element-2958">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2959">Incarichi</h1>
      </div>
      <Tabs className="mb-6" value={tab} onValueChange={setTab} items={[{
      id: 'attivi',
      label: 'Attivi'
    }, {
      id: 'completati',
      label: 'Completati'
    }]} data-id="element-2960" />
      {visible.length > 0 ? <div className="space-y-3" data-id="element-2961">
          {visible.map(j => <Card key={j.id} className="hover:border-coral/40 hover:shadow-sm transition-all" data-id="element-2962">
              <CardContent className="flex items-center justify-between gap-3 cursor-pointer" onClick={() => navigate(`/man/incarichi/${j.id}`)} data-id="element-2963">
                <div className="min-w-0" data-id="element-2964">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2965">
                    <h3 className="text-sm font-semibold text-foreground truncate" data-id="element-2966">
                      {j.title}
                    </h3>
                    <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full border flex-shrink-0 ${statusMap[j.status].cls}`} data-id="element-2967">
                      {statusMap[j.status].label}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground flex-wrap" data-id="element-2968">
                    <span className="flex items-center gap-1" data-id="element-2969">
                      <Home size={12} data-id="element-2970" />
                      {j.trade}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-2971">
                      <MapPin size={12} data-id="element-2972" />
                      {j.zone}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-2973">
                      <Clock size={12} data-id="element-2974" />
                      {j.date} · {j.time}
                    </span>
                    <span className="font-semibold text-foreground" data-id="element-2975">
                      €{j.earning}
                    </span>
                  </div>
                </div>
                <ChevronRight size={16} className="text-muted-foreground flex-shrink-0" data-id="element-2976" />
              </CardContent>
              {j.status === 'da_accettare' && <CardFooter data-id="element-2977">
                  <span className="text-xs text-muted-foreground" data-id="element-2978">
                    {j.property}
                  </span>
                  <Button size="sm" onClick={() => acceptJob(j.id)} data-id="element-2979">
                    <Check size={15} data-id="element-2980" />
                    Accetta
                  </Button>
                </CardFooter>}
            </Card>)}
        </div> : <div className="bg-white border border-border rounded-xl p-10 text-center" data-id="element-2981">
          <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mx-auto mb-3" data-id="element-2982">
            <Clock size={20} className="text-muted-foreground" data-id="element-2983" />
          </div>
          <p className="text-sm font-medium text-foreground" data-id="element-2984">
            {tab === 'attivi' ? 'Nessun incarico attivo' : 'Nessun incarico completato'}
          </p>
          <p className="text-xs text-muted-foreground mt-1" data-id="element-2985">
            {tab === 'attivi' ? 'Accetta opportunità di zona per riempire la tua agenda.' : 'Gli interventi completati appariranno qui.'}
          </p>
        </div>}
    </MobileLayout>;
}